import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyBBDYT9deGZCyEpD34TH_NxFKTP42sZFU8',
		authDomain: 'al-rowad-school-app.firebaseapp.com',
		projectId: 'al-rowad-school-app',
		storageBucket: 'al-rowad-school-app.firebasestorage.app',
		messagingSenderId: '164191529528',
		appId: '1:164191529528:web:cbf7c5818886a7d9a794cd'
	},
	publicKey: 'BDKizsWCFbUP-BRfRfP80SV0AFJIj7NkFSIBlOm1tY38WGZHRxrPtWM4ZugttPJvQW7NqvUTGnYcCHH9x24YsyA',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
